import { render, staticRenderFns } from "./AppNavigationDrawer.vue?vue&type=template&id=136e84fb"
import script from "./AppNavigationDrawer.vue?vue&type=script&lang=js"
export * from "./AppNavigationDrawer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports